/* eslint-disable @nx/enforce-module-boundaries */
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { DebtType, loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../utils/format';
import type { Step7Data } from '../../../FormData.dk.types';
import { radioOptions } from '../../../config/globals';
import { requiredUnregisterField } from '../../shared-config';
import { currentYearDebtOutstandingAmountFieldOptions } from './config';

export const ExtraDebtFormGroup = ({
  debts,
}: {
  debts: loan_application.Debt[];
}) => {
  const { t } = useTranslation();

  const hasCurrentYearDebt =
    useWatch({ name: 'Frontend/HasCurrentYearDebt' }) === 'Yes';

  const hasDebtCollection = debts.some(
    (debt) => debt.Type === DebtType.Collection
  );

  const askHasCurrentYearDebt = hasDebtCollection
    ? debts.length > 1
    : debts.length > 0;

  return (
    <>
      {askHasCurrentYearDebt && (
        <RadioFieldUI<Step7Data>
          name="Frontend/HasCurrentYearDebt"
          data-testid="has-current-year-debt-radio"
          label={t('HasCurrentYearDebt.label', {
            year: new Date().getFullYear(),
          })}
          radioStyle="both"
          options={radioOptions}
          registerOptions={requiredUnregisterField}
        />
      )}

      {hasCurrentYearDebt && (
        <NumberFieldUI<Step7Data>
          name="LoanApplication/CurrentYearDebtOutstandingAmount"
          label={t('CurrentYearDebtOutstandingAmount.label')}
          data-testid="current-year-debt-outstanding-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...currentYearDebtOutstandingAmountFieldOptions}
        />
      )}
    </>
  );
};
